import React, { useEffect, useState } from 'react';
import IrHeading from '../components/IrAboutYou/IrHeading';
import { BREAKPOINTS, Stack, Tabs, rem, useLang } from '@manulife/mux';
import NumberConstants from '../assets/appStyledComponents/numberConstant.json';
import useWindowSize from '../customHooks/useWindowSize';
import LABELS from '../assets/labels';
import IrTabBody from '../components/IrCommon/IrTabBody';
import IrLifeInputs from '../components/IrLifeInputs/IrLifeInputs';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import IrDisabilityInputs from '../components/IrDisabilityInputs/IrDisabilityInputs';
import IrCriticalIllnessInputs from '../components/IrCriticalIllnessInputs/IrCriticalIllnessInputs';
import { eCalculatorTab } from '../services/helpers/udmConstants';
import IrLifeResultSection from '../components/IrResultSection/IrLifeResultSection';
import IrDisabilityResultSection from '../components/IrResultSection/IrDisabilityResultSection';
import DefaultValues from './DefaultValues.json'
import IrCIResultSection from '../components/IrResultSection/IrCIResultSection';
import { setCurrTab } from '../appRedux/IrCalculator/Actions';

function IrCalculatorPage() {
    const { width: windowWidth } = useWindowSize();
    const selectedLang = useLang();
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const [tab, setTab] = useState(eCalculatorTab.life);

    const { num30, num32, num40, num64, num50, num100 } = NumberConstants;

    const storedAboutYouData = useSelector(
        (state) => state.irCalculatorReducer.data.step1
    );

    useEffect(() => {
        if (storedAboutYouData.you.irSex === "") {
            navigate("/about", { replace: true })
        }
        return () => null
    }, [navigate, storedAboutYouData]);

    const methods = useForm({
        defaultValues: DefaultValues
    });

    const tabs = [
        {
            id: eCalculatorTab.life,
            label: LABELS.tabs.life[`${selectedLang}`].label,
        },
        {
            id: eCalculatorTab.disability,
            label: LABELS.tabs.disability[`${selectedLang}`].label,
        },
        {
            id: eCalculatorTab.criticalIllness,
            label: LABELS.tabs.criticalIllness[`${selectedLang}`].label,
        },
    ]
    useEffect(() => {
        window.scrollTo({ top: 0 })
    }, []);
    useEffect(() => {
        dispatch(setCurrTab(tab));
    }, [tab, dispatch]);
    return (
        <Stack data-testid="IrCalculatorPageWrapper" align="flex-start" gap={`${rem(num30)}`} style={{
            maxWidth: `${rem(BREAKPOINTS.DESKTOP_STANDARD)}`,
            padding: windowWidth > BREAKPOINTS.TABLET_PORTRAIT ? `${rem(num40)} ${rem(num64)} ${rem(num50)} ${rem(num64)}` : `${rem(num32)} ${rem(0)} ${rem(0)} ${rem(0)}`
        }}>
            <IrHeading />
            <FormProvider {...methods} >
                <form style={{ width: `${num100}%` }} >
                    <Tabs
                        tabItems={tabs}
                        variant={Tabs.VARIANT.GREY}
                        tabAlignment={Tabs.ALIGNMENT.LEFT}
                        selectedTab={tab}
                        onChange={setTab}
                    >
                        <Tabs.Panel id={eCalculatorTab.life} style={{ padding: 'var(--cds-spacing-4)' }}>
                            <IrTabBody leftColComponent={<IrLifeInputs storedAboutYouData={storedAboutYouData} />} rightColComponent={<IrLifeResultSection />} />
                        </Tabs.Panel>
                        <Tabs.Panel id={eCalculatorTab.disability} style={{ padding: 'var(--cds-spacing-4)' }}>
                            <IrTabBody leftColComponent={<IrDisabilityInputs storedAboutYouData={storedAboutYouData} />} rightColComponent={<IrDisabilityResultSection />} />
                        </Tabs.Panel>
                        <Tabs.Panel id={eCalculatorTab.criticalIllness} style={{ padding: 'var(--cds-spacing-4)' }}>
                            <IrTabBody leftColComponent={<IrCriticalIllnessInputs storedAboutYouData={storedAboutYouData} />} rightColComponent={<IrCIResultSection selectedTab={tab} />} />
                        </Tabs.Panel>
                    </Tabs>
                </form>
            </FormProvider>
        </Stack>
    )
}

export default IrCalculatorPage;